import { createApiRef } from '@backstage/core-plugin-api';

import type {
  CatalogMetricsResponse,
  CustomMetricsQueryParams,
  HeadlinesMetricsResponse,
  OverviewMetricsResponse,
  SearchMetricsResponse,
  TemplatesMetricsResponse,
  UsersMetricsResponse,
} from './types';

/**
 * Frontend client for Custom Insights metrics.
 *
 * REST shape (real backend): `GET {base}/{segment}?from=&to=&userGroup=`
 * with segments: `catalog`, `headlines`, `overview`, `search`, `templates`, `users`.
 */
export interface CustomMetricsApi {
  getCatalog(params: CustomMetricsQueryParams): Promise<CatalogMetricsResponse>;
  getHeadlines(params: CustomMetricsQueryParams): Promise<HeadlinesMetricsResponse>;
  getOverview(params: CustomMetricsQueryParams): Promise<OverviewMetricsResponse>;
  getSearch(params: CustomMetricsQueryParams): Promise<SearchMetricsResponse>;
  getTemplates(params: CustomMetricsQueryParams): Promise<TemplatesMetricsResponse>;
  getUsers(params: CustomMetricsQueryParams): Promise<UsersMetricsResponse>;
}

export const customMetricsApiRef = createApiRef<CustomMetricsApi>({
  id: 'plugin.custom-metrics.metrics',
});
